import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import noop from 'lodash/noop';

import Icon from '../Icon';
import style from './Alert.module.scss';

export interface AlertProps {
  className: string;
  warning: boolean;
  error?: string;
  children?: React.ReactNode;
  dismissable?: boolean;
  onDismiss?: () => void;
}

export default function Alert(props: AlertProps) {
  const {
    className,
    warning,
    error,
    children,
    dismissable,
    onDismiss,
    ...otherProps
  } = props;

  return (
    <div
      className={classnames(
        style.alert,
        {
          [style.error]: error,
          [style.warning]: warning,
        },
        className,
      )}
      role="status"
      {...otherProps}
    >
      {children}
      {dismissable && (
        <Icon
          type="icon-cancel"
          className={style.dismiss}
          onClick={onDismiss}
          data-testid="icon-dismissAlert"
        />
      )}
    </div>
  );
}

Alert.propTypes = {
  /**
   * children to put inside the Alert
   */
  children: PropTypes.node,
  /**
   * html class
   */
  className: PropTypes.string,
  /**
   * specifies whether this is an error alert
   */
  error: PropTypes.bool,
  /**
   * specifies whether this is an warning alert
   */
  warning: PropTypes.bool,
  /**
   * adds a dismiss icon to the alert
   */
  dismissable: PropTypes.bool,
  /**
   * handler on dismiss
   */
  onDismiss: PropTypes.func,
};

Alert.defaultProps = {
  children: null,
  className: '',
  error: false,
  warning: false,
  dismissable: false,
  onDismiss: noop,
};

Alert.displayName = 'Alert';
